module.exports = __webpack_public_path__ + "img/minera-camino-rojo.0c7e735a.png";